import * as z from "zod";



/* ================= Product ================= */
export const baseProductSchema = z.object({
  barcode: z.string().max(255).optional().nullable(),
  name: z.string().min(1, "Name is required").max(255),
  description: z.string().optional().nullable(),
  status: z.enum(["active", "inactive", "draft"]).optional(),

 
  is_featured: z.int().optional(),
  is_active: z.int().optional(),

  store_id: z.number({message:"المتجر مطلوب"})
  .min(1, "Store is required")
,
  category_id: z.number("الفئة مطلوبة"),

  max_cart_quantity: z.number().int().min(1).optional().nullable(),
  weight: z.number().min(0).optional().nullable(),
});

/* ================= Availability ================= */
export const availabilitySchema = z.object({
  stock_quantity: z.number().int().min(0),
  is_in_stock: z.int(),
  available_start_date: z.string().optional().nullable(),
  available_end_date: z.string().optional().nullable(),
}).refine(
  (data) =>
    !data.available_start_date ||
    !data.available_end_date ||
    data.available_end_date >= data.available_start_date,
  {
    message: "End date must be after or equal start date",
    path: ["available_end_date"],
  }
);

/* ================= Images ================= */
export const imageSchema = z.object({
  file: z.instanceof(File ,{message:"image is requried"}),
  image_path:z.string(),
  is_primary: z.number().int().optional(),
});

/* ================= Prices ================= */
export const priceSchema = z.object({
  price: z.number().min(1),
  purchase_price: z.number().min(0).optional().nullable(),
  sale_price: z.number().min(0).optional().nullable(),  
});

/* ==============Addon============*/
export const addoneSechma =z.object({
  
})
export const restaurantSchema = {



  product: baseProductSchema,

  nutrition: z.object({}),

  availability: z.array(availabilitySchema),
  images:z.array(imageSchema),
  prices: priceSchema,
  addon:addoneSechma
} 

export const storeSchema = {
  product: baseProductSchema,
  nutrition: z.object({}),
  availability: z.array(availabilitySchema),
  images: z.array(imageSchema),
  prices: priceSchema,
};

export const pharmacyInfoSchema ={
  generic_name: z.string().max(255),
  common_use: z.string().max(255),
  prescription_required: z.int(),
};

export const pharmacySchema = {


  product: baseProductSchema,

  pharmacyInfo: z.array(pharmacyInfoSchema).min(1),

 availability: z.array(availabilitySchema),
  images: z.array(imageSchema),
  prices: priceSchema,
  addon:addoneSechma,
}
